import { useState } from 'react';

import {
  Button,
  Checkbox,
  ListImage,
  Typography,
} from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import theme from '../../theme';
import ConfirmationModalTechnician from '../ConfirmationModal/ConfirmationModal';
import { TechnicalTemplateStyled } from './style';
type Props = {
  templateCreateDate: string;
  country: { name: string; URL: string; id: string }[];
  templateTilte: string;
  uploadedTemplate: { id: string; URL: string }[];
};

const TemplateInformation = ({
  templateCreateDate,
  templateTilte,
  country,
  uploadedTemplate,
}: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [loading, _setLoading] = useState(false);
  const [selectedImages, setSelectedImages] = useState<string[]>([]);

  const handleCheckboxChange = (id: string) => {
    const isSelected = selectedImages.includes(id);
    if (isSelected) {
      setSelectedImages(selectedImages.filter((imageId) => imageId !== id));
    } else {
      setSelectedImages([...selectedImages, id]);
    }
  };

  const handleDownload = () => {
    selectedImages.forEach((id) => {
      const selectedImage = uploadedTemplate.find((image) => image.id === id);
      if (selectedImage) {
        const downloadLink = document.createElement('a');
        downloadLink.href = selectedImage.URL;
        downloadLink.download = `image_${selectedImage.id}.png`;
        downloadLink.click();
      }
    });
  };
  return (
    <TechnicalTemplateStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        TEMPLATE INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled className="templateInfo">
          <Typography fontColor="dark" className="key">
            Template Create Date :
          </Typography>
          <Typography variant="normal" className="value">
            {templateCreateDate}
          </Typography>
        </InfoRowStyled>
        <InfoRowStyled className="templateInfo">
          <Typography fontColor="dark" className="key">
            Template Title :
          </Typography>
          <Typography variant="normal" className="value">
            {templateTilte}
          </Typography>
        </InfoRowStyled>
        <InfoRowStyled className="templateInfo">
          <Typography fontColor="dark" className="key">
            Country :
          </Typography>
          <InfoRowStyled $direction="row">
            {country.map((Props, index) => (
              <div key={index} style={{ display: 'flex' }}>
                <img
                  src={Props.URL}
                  alt="Flag"
                  style={{
                    height: '24px',
                    width: '24px',
                    borderRadius: '50%',
                    marginRight: '12px',
                  }}
                />
                <Typography variant="normal" className="value">
                  {Props.name}
                </Typography>
              </div>
            ))}
          </InfoRowStyled>
        </InfoRowStyled>
        <Typography fontColor="dark" className="key">
          Uploaded Template :
        </Typography>
        <div
          style={{
            display: 'flex',
            width: '100%',
            gap: '20px',
            flexWrap: 'wrap',
          }}
        >
          {Array.isArray(uploadedTemplate)
            ? uploadedTemplate.map((image: any) => (
                <div
                  key={image.id}
                  style={{
                    position: 'relative',
                    border: selectedImages.includes(image.id)
                      ? `2px solid ${theme.colors.secondary}`
                      : `2px solid ${theme.colors.transparent}`,
                  }}
                >
                  <Checkbox
                    style={{
                      position: 'absolute',
                      top: '5px',
                      right: '5px',
                      zIndex: 1,
                    }}
                    checked={selectedImages.includes(image.id)}
                    onChange={() => handleCheckboxChange(image.id)}
                  />
                  <ListImage imagesURL={[image]} />
                </div>
              ))
            : []}
        </div>
        {/* {uploadedTemplate.map((Props, index) => (
            <div key={index}>
              <InfoRowStyled className="blueprintInfo"></InfoRowStyled>
              <ListImage
                imagesURL={[{ URL: Props.URL, id: Props.id }]}
                imageHeight="143px"
                imageWidth="192px"
              />
            </div>
          ))}
        </InfoRowStyled> */}
        <Button
          variant="secondary"
          onClick={handleDownload}
          isLoading={loading}
          disabled={selectedImages.length === 0}
        >
          Download
        </Button>
      </VerticalSpaceStyled>
      {isOpen ? (
        <ConfirmationModalTechnician
          message="Are you sure want to download?"
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        >
          {
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '0 20px',
              }}
            >
              <Button
                size="sm"
                variant="secondary"
                style={{ width: 80 }}
                onClick={() => alert('Confirmation Affirmative')}
              >
                <Typography variant="normal" fontColor="white">
                  Yes
                </Typography>
              </Button>
              <Button
                size="sm"
                variant="cancel"
                style={{ width: 80 }}
                onClick={() => setIsOpen(false)}
              >
                <Typography variant="normal">No</Typography>
              </Button>
            </div>
          }
        </ConfirmationModalTechnician>
      ) : (
        ''
      )}
    </TechnicalTemplateStyled>
  );
};

export default TemplateInformation;
